class PredictiveSearch {
    constructor() {
        this.container = document.querySelector('.search-wrapper');
        this.input = document.getElementById('searchInput');
        this.resultsContainer = document.getElementById('predictive-search-results');
        this.overlay = document.getElementById('searchOverlay');

        if (!this.input || !this.resultsContainer) return;

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300));

        // Close on click outside
        document.addEventListener('click', (event) => {
            if (!this.container.contains(event.target)) {
                this.close();
            }
        });
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
        this.resultsContainer.classList.add('active', 'loading');
        this.resultsContainer.innerHTML = '<div class="predictive-search__loading"><div class="spinner"></div></div>';

        try {
            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,article&resources[limit]=4&section_id=predictive-search`);

            // Shopify has a specific endpoint for predictive search that can return HTML if configured with a section,
            // but suggest.json is more reliable for custom rendering.
            const data = await response.json();
            this.renderResults(data, searchTerm);
        } catch (error) {
            console.error('Predictive Search Error:', error);
            this.close();
        }
    }

    renderResults(data, searchTerm) {
        this.resultsContainer.classList.remove('loading');
        const products = data.resources.results.products;

        if (products.length === 0) {
            this.resultsContainer.innerHTML = '<div class="predictive-search__results"><p>No results found for "' + searchTerm + '"</p></div>';
            return;
        }

        let html = `
      <div class="predictive-search__results">
        <div class="predictive-search__heading">
          Products
          <span>${products.length} found</span>
        </div>
        <div class="predictive-search__list">
    `;

        products.forEach(product => {
            html += `
        <a href="${product.url}" class="predictive-search__item">
          <img src="${product.image ? product.image : ''}" class="predictive-search__image" alt="${product.title}">
          <div class="predictive-search__info">
            <span class="predictive-search__title">${product.title}</span>
            <span class="predictive-search__price">${product.price}</span>
          </div>
        </a>
      `;
        });

        html += `
        </div>
      </div>
      <a href="/search?q=${encodeURIComponent(searchTerm)}" class="predictive-search__all-link">
        View all results
      </a>
    `;

        this.resultsContainer.innerHTML = html;
    }

    close() {
        this.resultsContainer.classList.remove('active');
        this.resultsContainer.innerHTML = '';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.predictiveSearch = new PredictiveSearch();
});
